<template>
    <main class="max-width-container with-backdrop">
        <BackdropImage :src="trip?.user_image_url" />
        <h1 class="form-title">Edit trip</h1>
        <SharedCopyNotice :shared-by="trip?.shared_by" item-label="trip" />
        <TripForm
            v-if="trip"
            :initial-values="trip"
            validated
            can-delete
            :trip="trip"
            :back-link="`/trips/${id}`"
            :errors="errors"
            @submit-form="submitForm"
            @delete="deleteTrip"
            @clear-error="clearError"
        />
    </main>
</template>

<script>
import TripForm from "js/components/forms/TripForm";
import BackdropImage from "js/components/common/BackdropImage";
import SharedCopyNotice from "js/components/common/SharedCopyNotice";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import { useTripStore } from "js/stores/tripStore";
import { useUtilsStore } from "js/stores/utilsStore";
import { useUserStore } from "js/stores/userStore";
import { usePageErrorStore } from "js/stores/pageErrorStore";
import { pageErrorFrom } from "js/lib/server.js";

export default {
    name: "TripEdit",
    components: {
        TripForm,
        BackdropImage,
        SharedCopyNotice,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            id: null,
            store: undefined,
            userStore: undefined,
            utilsStore: undefined,
            trip: null,
            errors: {},
        };
    },
    async mounted() {
        this.id = parseInt(this.$route.params.id);
        this.store = useTripStore();
        this.utilsStore = useUtilsStore();
        this.userStore = useUserStore();
        try {
            this.trip = await this.store.fetch(`/api/trips/${this.id}`);
        } catch (err) {
            usePageErrorStore().set(pageErrorFrom(err));
        }
    },
    methods: {
        async submitForm(data) {
            this.store
                .edit(`/api/trips/${this.id}`, data, !!data.user_image_file)
                .then(async (data) => {
                    data.id = this.id;
                    this.store.update(data);
                    await this.userStore.refreshUser().catch(() => {});
                    this.$router.push(`/trips/${this.id}`);
                })
                .catch(this.handleResponseErrors);
            if (data.companions) {
                this.utilsStore.invalidate("companions");
            }
        },
        deleteTrip() {
            this.store
                .delete(`/api/trips/${this.id}?with-locations`)
                .then(() => {
                    this.store.remove(this.id);
                    this.$router.push("/trips");
                });
        },
    },
};
</script>
